// Lightweight gtag event helper. Safe to call anywhere; no-ops on server
// and when gtag hasn't loaded yet.
type GtagArgs = [string, string, Record<string, unknown>?];

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: (...args: GtagArgs) => void }).gtag;
  try {
    if (typeof gtag === "function") {
      gtag("event", name, params);
    } else {
      // Queue via dataLayer so events aren't lost before gtag.js loads.
      const w = window as unknown as { dataLayer?: unknown[] };
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push({ event: name, ...params });
    }
  } catch {
    /* ignore analytics errors */
  }
}
